import { AbstractControl } from '@angular/forms';
import { isValidIMEI } from '../helper-functions';

export function ValidateIMEI(control: AbstractControl): null | { [key: string]: boolean } {
    const value = control.value;
    if (value === null || value === '' || typeof value === 'undefined') {
        return null;
    }

    if (!/^[0-9]{15}$/gm.test(value)) {
        return { notAnIMEI: true };
    }

    if (!isValidIMEI(value)) {
        return { invalidIMEI: true };
    }

    return null;
}
